// extracted by mini-css-extract-plugin
export default {"saveSearchButton":"SmallButton_saveSearchButton__R2Z4j"};